<template>
  <div class="card">
    <div style="display:flex;align-items:center;justify-content:space-between;">
      <h3 style="margin:0;">Top del mes</h3>
      <select class="input" v-model="game" style="max-width:220px;" @change="load">
        <option value="">Todos</option>
        <option v-for="g in games" :key="g.code" :value="g.code">{{ g.name }} ({{ g.code }})</option>
      </select>
    </div>
    <table class="table" style="margin-top:10px;">
      <thead><tr><th>#</th><th>Jugador</th><th>Ganados</th><th>Puntos</th></tr></thead>
      <tbody>
      <tr v-for="(row, idx) in top5" :key="row.userId">
        <td>{{ idx + 1 }}</td>
        <td>{{ row.displayName || ('Jugador ' + row.userId) }}</td>
        <td>{{ row.tournamentsWon }}</td>
        <td>{{ row.totalMatchPoints }}</td>
      </tr>
      </tbody>
    </table>
    <p v-if="!top5.length" style="margin-top:8px;">Sin datos este mes.</p>
  </div>
</template>

<script>
import api from '../services/api';

function monthRange(date = new Date()) {
  const y = date.getFullYear(), m = date.getMonth();
  const from = new Date(y, m, 1);
  const to = new Date(y, m + 1, 0);
  const fmt = d => d.toISOString().slice(0, 10);
  return { from: fmt(from), to: fmt(to) };
}

export default {
  props: { defaultGame: { type: String, default: '' } },
  data: () => ({ games: [], game: '', rows: [] }),
  computed: {
    top5() { return this.rows.slice(0, 5); }
  },
  async created() {
    const g = await api.get('/api/games'); this.games = g.data;
    this.game = this.defaultGame || '';
    await this.load();
  },
  methods: {
    async load() {
      const { from, to } = monthRange(new Date());
      const params = { from, to };
      if (this.game) params.game = this.game;
      const { data } = await api.get('/api/stats/leaderboard', { params });
      this.rows = data;
    }
  }
}
</script>
